<script setup lang="ts">

import { computed } from 'vue';
import { usePresentation } from '@/modules/Presentation/Types';
import { useLead } from "../../Types/Lead";
import { Map } from '../../Types/Map';
import { Dojo } from '../../Types/LeadOptions';

const lead = useLead();
const presentation = usePresentation();

presentation.backgroundImage = '/images/sample/gkr-watermark.png';
presentation.onSetNext = () => ({ section: Map.PresentOffer, page: 0 });

const dojo = computed( () => 
{
    if( lead.dojo == Dojo.mossVale )
    {
        return {
            title: 'Moss Vale Dojo',
            preview: '/HowCanWeHelp/gkr-r17-mossvale-preview.jpg',
            video: '~/video/gkr/gkr-r17-mossvale.mp4',
            timetable: '/HowCanWeHelp/gkr-r17-mossvale-timetable.jpg'
        }
    }
    return {
        title: 'Wollongong Dojo',
        preview: '/HowCanWeHelp/gkr-r17-wollongong-preview.jpg',
        video: '~/video/gkr/gkr-r17-wollongong.mp4',
        timetable: '/HowCanWeHelp/gkr-r17-wollongong-timetable.jpg'
    }
});


</script>

<template>
    <Page>
        <h1 class="text-3xl font-semibold">{{ dojo.title }}</h1>
        <div v-if="lead.dojo != null"
             class="grid grid-cols-2 gap-8 mb-8 pt-8">
            <div class="cursor-pointer" @click="() => presentation.displayMedia( dojo.video )">
                <Image :src="dojo.preview" class="rounded-lg shadow-xl h-full bg-white p-1 object-cover" />
                <div class="absolute bottom-1 left-1 right-1 bg-slate-800/90 rounded-lg p-4 shadow-xl">
                    <div class="text-lg font-semibold">
                        Your Dojo, {{lead.dojo!.toString()}}<br/>Click to see inside
                    </div>
                </div>
            </div>
            <div class="cursor-pointer" @click="() => presentation.displayMedia( dojo.timetable )">
                <Image :src="dojo.timetable" class="rounded-lg shadow-xl bg-white p-1 object-cover" />
                <div class="absolute bottom-1 left-1 right-1 bg-slate-800/90 rounded-lg p-4 shadow-xl">
                    <div class="text-lg font-semibold">
                        Want to find out when classes run, who’s teaching, and what to expect on your first visit?
                    </div>
                </div>
            </div>
        </div>
    </Page>
</template>